import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminRouteDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [route, setRoute] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null); // 'approve' or 'reject'
  const [modalData, setModalData] = useState({
    sinister: '',
    comments: ''
  });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchRoute();
  }, [id]);

  const fetchRoute = async () => {
    try {
      const res = await axios.get(`/api/routes/${id}`);
      console.log('Route data:', res.data);
      console.log('Acceptance requests:', res.data.acceptanceRequests);
      setRoute(res.data);
    } catch (error) {
      console.error('Error fetching route:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (type) => {
    setModalType(type);
    setModalData({ sinister: '', comments: '' });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalType(null);
    setModalData({ sinister: '', comments: '' });
  };

  const handleSubmitModal = async () => {
    if (!modalType) return;
    
    // Validate required fields when rejecting
    if (modalType === 'reject') {
      if (!modalData.sinister || !modalData.sinister.trim()) {
        alert('El campo Siniestro es requerido al rechazar la ruta');
        return;
      }
      if (!modalData.comments || !modalData.comments.trim()) {
        alert('El campo Comentarios es requerido al rechazar la ruta');
        return;
      }
    }
    
    setSubmitting(true);
    try {
      let endpoint;
      if (modalType === 'approve') {
        endpoint = `/api/admin/routes/${id}/approve-waybill`;
      } else if (modalType === 'reject') {
        endpoint = `/api/admin/routes/${id}/reject-waybill`;
      } else if (modalType === 'return') {
        endpoint = `/api/admin/routes/${id}/return-waybill`;
      }
      
      await axios.put(endpoint, modalData);
      handleCloseModal();
      fetchRoute();
      alert(modalType === 'approve' 
        ? 'Ruta aprobada exitosamente' 
        : modalType === 'reject'
        ? 'Ruta rechazada exitosamente'
        : 'Guía devuelta para corrección exitosamente');
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.errors?.[0]?.msg || 
                          `Error al ${modalType === 'approve' ? 'aprobar' : modalType === 'reject' ? 'rechazar' : 'devolver'} la ruta`;
      alert(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };


  if (loading) {
    return <div className="loading">Cargando detalles de la ruta...</div>;
  }

  if (!route) {
    return <div className="card">Ruta no encontrada</div>;
  }

  const statusMap = {
    'pending': 'Pendiente',
    'approved': 'Aprobada',
    'pending-acceptance': 'Pendiente Aceptación',
    'accepted': 'Aceptada',
    'in-progress': 'En Progreso',
    'pending-approval': 'Pendiente Aprobación',
    'completed': 'Completada',
    'rejected': 'Rechazada'
  };

  // Get badge class based on status
  const getBadgeClass = (status) => {
    if (status === 'pending') return 'badge badge-pending';
    if (status === 'approved') return 'badge badge-approved';
    if (status === 'accepted') return 'badge badge-accepted';
    if (status === 'in-progress') return 'badge badge-in-progress';
    if (status === 'pending-approval') return 'badge badge-pending-approval';
    if (status === 'pending-acceptance') return 'badge badge-pending-acceptance';
    if (status === 'completed') return 'badge badge-completed';
    if (status === 'rejected') return 'badge badge-rejected';
    return 'badge badge-pending';
  };

  return (
    <div>
      <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
        <button className="btn btn-secondary" onClick={() => navigate('/admin/routes')} style={{ minWidth: '120px' }}>
          ← Volver a Rutas
        </button>
        <h2 style={{ margin: 0, fontSize: 'clamp(18px, 4vw, 24px)' }}>Detalles de la Ruta: {route.routeNumber}</h2>
      </div>
      
      <div className="card">
        <h3>Información Básica</h3>
        {route.startPoint && <p><strong>Punto de Inicio:</strong> {route.startPoint}</p>}
        <p><strong>Destino:</strong> {route.endPoint}</p>
        {route.retreatDay && <p><strong>Día de Retiro:</strong> {new Date(route.retreatDay).toLocaleDateString('es-ES')}</p>}
        {route.wineryHours && <p><strong>Horario de Bodega:</strong> {route.wineryHours}</p>}
        {route.warehouseSchedule2 && <p><strong>Horario de Almacén 2:</strong> {route.warehouseSchedule2}</p>}
        {route.warehousePickupSchedule && <p><strong>Horario de Recogida en Almacén:</strong> {route.warehousePickupSchedule}</p>}
        {route.warehousePickupSchedule2 && <p><strong>Horario de Recogida en Almacén 2:</strong> {route.warehousePickupSchedule2}</p>}
        {route.arrivalAtDestinationDeliveryDay && <p><strong>Día de Llegada al Destino - Día de Entrega:</strong> {new Date(route.arrivalAtDestinationDeliveryDay).toLocaleDateString('es-ES')}</p>}
        <p><strong>Estado:</strong> <span className={getBadgeClass(route.status)} style={{ textTransform: 'none' }}>{statusMap[route.status] || 'Pendiente'}</span></p>
        {route.assignedTo && <p><strong>Transporte:</strong> {route.assignedTo.companyName || route.assignedTo.name} ({route.assignedTo.email})</p>}
        {route.pendingAcceptanceBy && !route.assignedTo && (
          <p><strong>Pendiente de Aceptación Por:</strong> {route.pendingAcceptanceBy.name} ({route.pendingAcceptanceBy.email})</p>
        )}
      </div>

      {route.assignedTo ? (
        <div className="card">
          <h3>Información del Transporte</h3>
          <p><strong>Empresa de Transporte:</strong> {route.assignedTo.companyName || route.assignedTo.name} ({route.assignedTo.email})</p>
          
          {route.initialInfo ? (
            <div style={{ marginTop: '15px', padding: '15px', background: '#f8f9fa', borderRadius: '4px' }}>
              <h4 style={{ marginBottom: '10px' }}>Información Inicial</h4>
              <p><strong>Nombre del Conductor:</strong> {route.initialInfo.driverName || 'No proporcionado'}</p>
              <p><strong>RUT:</strong> {route.initialInfo.rut || 'No proporcionado'}</p>
              <p><strong>Patente del Tracto:</strong> {route.initialInfo.truckLicensePlate || 'No proporcionado'}</p>
              <p><strong>Patente de Rampla Celular:</strong> {route.initialInfo.trailerLicensePlate || 'No proporcionado'}</p>
              {route.initialInfo.comments && <p><strong>Comentarios:</strong> {route.initialInfo.comments}</p>}
              {route.initialInfo.submittedAt && <p><strong>Enviado:</strong> {new Date(route.initialInfo.submittedAt).toLocaleString('es-ES')}</p>}
            </div>
          ) : (
            <div style={{ marginTop: '15px', padding: '15px', background: '#fff3cd', borderRadius: '4px', color: '#856404' }}>
              <p>El transporte aún no ha enviado la información inicial.</p>
            </div>
          )}
          
          {route.finalInfo ? (
            <div style={{ marginTop: '15px', padding: '15px', background: '#d1ecf1', borderRadius: '4px' }}>
              <h4 style={{ marginBottom: '10px' }}>Información Final</h4>
              <p><strong>Hora de Llegada:</strong> {route.finalInfo.arrivalTime || 'No proporcionado'}</p>
              {route.finalInfo.arrivalDay && <p><strong>Día de Llegada:</strong> {new Date(route.finalInfo.arrivalDay).toLocaleDateString('es-ES')}</p>}
              <p><strong>Guías:</strong> {route.finalInfo.guides || 'No proporcionado'}</p>
              {route.finalInfo.sinister && <p><strong>Siniestro:</strong> {route.finalInfo.sinister}</p>}
              {route.finalInfo.comments && <p><strong>Comentarios:</strong> {route.finalInfo.comments}</p>}
              {route.finalInfo.receptionBellPhoto && (
                <div style={{ marginTop: '10px' }}>
                  <p><strong>Foto de Timbre de Recepción:</strong></p>
                  <img 
                    src={`http://localhost:5000${route.finalInfo.receptionBellPhoto.path}`} 
                    alt="Timbre de Recepción"
                    style={{ maxWidth: '300px', height: 'auto', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer' }}
                    onClick={() => window.open(`http://localhost:5000${route.finalInfo.receptionBellPhoto.path}`, '_blank')}
                  />
                </div>
              )}
              {route.finalInfo.submittedAt && <p style={{ marginTop: '10px' }}><strong>Enviado:</strong> {new Date(route.finalInfo.submittedAt).toLocaleString('es-ES')}</p>}
              
              {/* Show approve/reject/return buttons when status is pending-approval */}
              {route.status === 'pending-approval' && (
                <div style={{ marginTop: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <button 
                    className="btn btn-success" 
                    onClick={() => handleOpenModal('approve')}
                  >
                    Aprobar Ruta
                  </button>
                  <button 
                    className="btn btn-warning" 
                    onClick={() => handleOpenModal('return')}
                    style={{ backgroundColor: '#f59e0b', color: 'white', border: 'none' }}
                  >
                    Devolver
                  </button>
                  <button 
                    className="btn btn-danger" 
                    onClick={() => handleOpenModal('reject')}
                  >
                    Rechazar Ruta
                  </button>
                </div>
              )}
              
              {/* Show admin feedback if available */}
              {route.adminFeedback && (
                <div style={{ marginTop: '20px', padding: '15px', background: '#e7f3ff', borderRadius: '4px' }}>
                  <h4 style={{ marginBottom: '10px' }}>Retroalimentación del Administrador</h4>
                  {route.adminFeedback.sinister && <p><strong>Siniestro:</strong> {route.adminFeedback.sinister}</p>}
                  {route.adminFeedback.comments && <p><strong>Comentarios:</strong> {route.adminFeedback.comments}</p>}
                  {route.adminFeedback.reviewedAt && (
                    <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                      Revisado: {new Date(route.adminFeedback.reviewedAt).toLocaleString('es-ES')}
                    </p>
                  )}
                </div>
              )}
            </div>
          ) : route.status === 'in-progress' && (
            <div style={{ marginTop: '15px', padding: '15px', background: '#fff3cd', borderRadius: '4px', color: '#856404' }}>
              <p>El transporte aún no ha enviado la información final.</p>
            </div>
          )}
        </div>
      ) : null}

      {(route.acceptanceRequests && route.acceptanceRequests.length > 0) ? (
        <div className="card">
          <h3>Solicitudes de Aceptación ({route.acceptanceRequests.filter(req => req.status === 'pending').length} Pendientes)</h3>
          {route.acceptanceRequests.map((request, index) => {
            const requestStatusMap = {
              'pending': 'Pendiente',
              'approved': 'Aprobada',
              'rejected': 'Rechazada'
            };
            return (
              <div 
                key={request._id || index} 
                style={{ 
                  marginBottom: '20px', 
                  padding: '15px', 
                  background: request.status === 'pending' ? '#fff3cd' : request.status === 'approved' ? '#d4edda' : '#f8d7da',
                  border: `1px solid ${request.status === 'pending' ? '#ffeaa7' : request.status === 'approved' ? '#c3e6cb' : '#f5c6cb'}`,
                  borderRadius: '4px' 
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '10px' }}>
                  <div>
                    <p style={{ margin: 0, fontWeight: 'bold' }}>
                      {request.user?.name || 'Usuario Desconocido'} ({request.user?.email || 'N/A'})
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '12px', color: '#666' }}>
                      Enviado: {new Date(request.submittedAt).toLocaleString('es-ES')}
                    </p>
                  </div>
                  <span className={`badge badge-${request.status === 'pending' ? 'warning' : request.status === 'approved' ? 'success' : 'danger'}`}>
                    {requestStatusMap[request.status] || request.status}
                  </span>
                </div>
                <div style={{ marginTop: '10px' }}>
                  <p><strong>Nombre del Conductor:</strong> {request.driverName}</p>
                  <p><strong>Placa del Camión:</strong> {request.truckLicensePlate}</p>
                  <p><strong>Placa del Remolque:</strong> {request.trailerLicensePlate}</p>
                  {request.comments && (
                    <p><strong>Comentarios:</strong> {request.comments}</p>
                  )}
                </div>
                {request.status === 'pending' && (
                  <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
                    <button 
                      className="btn btn-success" 
                      onClick={async () => {
                        if (window.confirm(`¿Aprobar la solicitud de aceptación de ${request.user?.name}? Todas las demás solicitudes pendientes serán rechazadas.`)) {
                          try {
                            await axios.put(`/api/admin/routes/${id}/approve-acceptance/${request._id}`);
                            fetchRoute();
                          } catch (error) {
                            alert(error.response?.data?.message || 'Error al aprobar la aceptación');
                          }
                        }
                      }}
                    >
                      Aprobar
                    </button>
                    <button 
                      className="btn btn-danger" 
                      onClick={async () => {
                        if (window.confirm(`¿Rechazar la solicitud de aceptación de ${request.user?.name}?`)) {
                          try {
                            await axios.put(`/api/admin/routes/${id}/reject-acceptance/${request._id}`);
                            fetchRoute();
                          } catch (error) {
                            alert(error.response?.data?.message || 'Error al rechazar la aceptación');
                          }
                        }
                      }}
                    >
                      Rechazar
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="card">
          <h3>Solicitudes de Aceptación</h3>
          <p style={{ color: '#999' }}>Aún no hay solicitudes de aceptación. Los usuarios pueden aceptar esta ruta para enviar sus solicitudes.</p>
        </div>
      )}

      {(!route.assignedTo && (!route.acceptanceRequests || route.acceptanceRequests.length === 0)) && (
        <div className="card">
          <p style={{ color: '#999' }}>Aún no hay solicitudes de aceptación. Los usuarios pueden aceptar esta ruta para enviar sus solicitudes.</p>
        </div>
      )}

      {route.tripUpdates && route.tripUpdates.length > 0 && (
        <div className="card">
          <h3>Actualizaciones del Viaje</h3>
          {route.tripUpdates.map((update, index) => {
            const updateTypeMap = {
              'started': 'Iniciado',
              'in-transit': 'En Tránsito',
              'delayed': 'Retrasado',
              'completed': 'Completado',
              'incident': 'Incidente'
            };
            return (
              <div key={index} style={{ marginBottom: '15px', padding: '10px', background: '#f8f9fa', borderRadius: '4px' }}>
                <p><strong>Tipo:</strong> {updateTypeMap[update.updateType] || update.updateType}</p>
                <p><strong>Descripción:</strong> {update.description}</p>
                {update.location && <p><strong>Ubicación:</strong> {update.location}</p>}
                <p><strong>Hora:</strong> {new Date(update.timestamp).toLocaleString('es-ES')}</p>
              </div>
            );
          })}
        </div>
      )}

      {route.comments && route.comments.length > 0 && (
        <div className="card">
          <h3>Comentarios</h3>
          {route.comments.map((comment, index) => (
            <div key={index} style={{ marginBottom: '10px', padding: '10px', background: '#f8f9fa', borderRadius: '4px' }}>
              <p>{comment.text}</p>
              <small>{new Date(comment.addedAt).toLocaleString('es-ES')}</small>
            </div>
          ))}
        </div>
      )}

      {route.purchaseOrderId && (
        <div className="card">
          <h3>Orden de Compra</h3>
          <p>Esta ruta está asociada con una orden de compra.</p>
        </div>
      )}

      {/* Modal for Approve/Reject */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '40px',
            maxWidth: '600px',
            width: '100%',
            maxHeight: '90vh',
            overflow: 'auto',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            position: 'relative',
            border: '1px solid #e5e7eb'
          }}>
            <button
              onClick={handleCloseModal}
              disabled={submitting}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: '#ef4444',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '36px',
                height: '36px',
                cursor: submitting ? 'not-allowed' : 'pointer',
                fontSize: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                opacity: submitting ? 0.5 : 1
              }}
              onMouseEnter={(e) => {
                if (!submitting) {
                  e.target.style.background = '#dc2626';
                  e.target.style.transform = 'scale(1.1)';
                }
              }}
              onMouseLeave={(e) => {
                if (!submitting) {
                  e.target.style.background = '#ef4444';
                  e.target.style.transform = 'scale(1)';
                }
              }}
            >
              ×
            </button>
            
            <h3 style={{ 
              marginBottom: '24px', 
              color: modalType === 'approve' ? '#10b981' : modalType === 'return' ? '#f59e0b' : '#ef4444',
              fontSize: '24px',
              fontWeight: '600',
              paddingRight: '40px'
            }}>
              {modalType === 'approve' ? '✓ Aprobar Ruta' : modalType === 'return' ? '↩️ Devolver Guía' : '✕ Rechazar Ruta'}
            </h3>
            
            {modalType !== 'return' && (
              <div className="form-group" style={{ marginBottom: '20px' }}>
                <label style={{ 
                  display: 'block', 
                  marginBottom: '8px', 
                  fontWeight: '600', 
                  color: '#374151',
                  fontSize: '14px'
                }}>
                  Siniestro {modalType === 'reject' && <span style={{ color: '#ef4444' }}>*</span>}
                </label>
                <input
                  type="text"
                  value={modalData.sinister}
                  onChange={(e) => setModalData({ ...modalData, sinister: e.target.value })}
                  placeholder={modalType === 'reject' ? 'Información sobre siniestros (requerido)' : 'Información sobre siniestros (opcional)'}
                  required={modalType === 'reject'}
                  disabled={submitting}
                  style={{ 
                    width: '100%', 
                    padding: '12px 16px', 
                    border: '2px solid #e5e7eb', 
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'all 0.2s',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                />
              </div>
            )}
            
            <div className="form-group" style={{ marginBottom: '24px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '600', 
                color: '#374151',
                fontSize: '14px'
              }}>
                Comentarios {modalType === 'reject' && <span style={{ color: '#ef4444' }}>*</span>}
                {modalType === 'return' && <span style={{ color: '#6b7280', fontSize: '12px', fontWeight: 'normal' }}> (Opcional - razón de la devolución)</span>}
              </label>
              <textarea
                value={modalData.comments}
                onChange={(e) => setModalData({ ...modalData, comments: e.target.value })}
                placeholder={modalType === 'reject' ? 'Comentarios adicionales (requerido)' : modalType === 'return' ? 'Razón de la devolución (opcional). Ej: La foto no es clara, necesita ser reenviada' : 'Comentarios adicionales (opcional)'}
                required={modalType === 'reject'}
                disabled={submitting}
                rows="4"
                style={{ 
                  width: '100%', 
                  padding: '12px 16px', 
                  border: '2px solid #e5e7eb', 
                  borderRadius: '8px', 
                  resize: 'vertical',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                  transition: 'all 0.2s',
                  outline: 'none'
                }}
                onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
              />
            </div>
            
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '28px' }}>
              <button 
                className="btn btn-secondary" 
                onClick={handleCloseModal}
                disabled={submitting}
                style={{
                  padding: '10px 20px',
                  borderRadius: '8px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                  border: 'none',
                  cursor: submitting ? 'not-allowed' : 'pointer',
                  opacity: submitting ? 0.5 : 1
                }}
                onMouseEnter={(e) => {
                  if (!submitting) {
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                Cancelar
              </button>
              <button 
                className={modalType === 'approve' ? 'btn btn-success' : modalType === 'return' ? 'btn btn-warning' : 'btn btn-danger'}
                onClick={handleSubmitModal}
                disabled={submitting}
                style={{
                  padding: '10px 24px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  transition: 'all 0.2s',
                  border: 'none',
                  cursor: submitting ? 'not-allowed' : 'pointer',
                  opacity: submitting ? 0.5 : 1,
                  backgroundColor: modalType === 'return' ? '#f59e0b' : undefined,
                  color: modalType === 'return' ? 'white' : undefined
                }}
                onMouseEnter={(e) => {
                  if (!submitting) {
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                {submitting ? '⏳ Procesando...' : (modalType === 'approve' ? '✓ Aprobar' : modalType === 'return' ? '↩️ Devolver' : '✕ Rechazar')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminRouteDetails;
